import React from "react";

const PatientActionButton = (
  { icon, text, callBack, styles = {} },
  classnames = ""
) => {
  return (
    <button
      onClick={callBack}
      style={styles}
      className={`patient-action-button ${classnames}`}
    >
      {icon}
      {text}
    </button>
  );
};

export default PatientActionButton;
